import CheckedCheckBox from '../../../assets/icons/CheckedCheckBox';
import React from 'react';
import './RemovableList.scss';
import Button from '../Button/Button';
import {Grid} from '@mui/material';


const RemovableList = ({title, items, onRemove, noElementsText, attributeToDisplayFromItem, buttonText, buttonOnClick}) => {
    return (
        <div className={'removable-list-container'}>
            <div className={'removable-list-title'}>
                <p className={'subtitle-1 v2-c-text-title'}>{title}</p>
                {buttonText && <Button size={'small'} onClick={buttonOnClick}>{buttonText}</Button>}
            </div>
                <Grid container spacing={1} className={'list-container'}>
                {items.length > 0 ? items.map((item, index) => {
                    return (
                        <Grid item xs={3} key={index}>
                             <div key={index} className={'removable-list-item-container'}>
                                <div onClick={() => onRemove(item)} className={'cursor-pointer'}>
                                    <CheckedCheckBox width={20} height={20}/>
                                </div>
                                <p className={'body-3 c-text-base removable-item-text'} title={item[attributeToDisplayFromItem]}>{item[attributeToDisplayFromItem]}</p>
                             </div>
                        </Grid>
                    );
                }) : <Grid item xs={5} key={0}><p className={'body-2 c-disabled'}>{noElementsText}</p></Grid>}
                </Grid>
        </div>

    );
};
export default RemovableList;
